import React, { useState, useCallback, useEffect } from "react";
// hook
import { date } from "../../../modules/components/numberFormat/NumberFormat.Date";
// UI
import { useStyles } from "../hooks/information.userStyles";
// import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { Link } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
// language
import { useLocale } from "../../../modules/hooks/UseLocale";
// import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import { GetPrivateAppRoutePath, PathKey } from "../../../pages/AppRoutes";

export const SummaryRepairInformation = (props: any) => {
  const classes = useStyles();
  const {
    data,
    errorType,
    repairHistoryList,
    openHistory,
    closeHistory,
    showHistoryFlg,
    changeView,
    changeData,
    // preApproveFlagError,
    formList,
    dataList,
    userPermisssionInfo,
  } = props;
  console.log("repair information", formList);
  // language
  const { t } = useLocale({ defaultPath: "modules.components.claim_detail" });
  const { com } = useLocale({ defaultPath: "common.constants" });

  // fetch the error type name from constants
  const getErrorTypeName = (code: string) => {
    let errorTypeName = "";
    let errorTypeList: any = [];
    if (Array.isArray(errorType)) {
      errorTypeList = errorType;
    }
    if (code && code !== "") {
      for (let index in errorTypeList) {
        if (Number(errorTypeList[index].error_type) === Number(code)) {
          errorTypeName = errorTypeList[index].error_description;
          break;
        }
      }
    }
    return errorTypeName;
  };

  // fetch the condition of tool name from constants
  const getConditionOfToolName = (code: string) => {
    let conditionOfToolName = "";
    let conditionOfToolList: any = [];
    if (Array.isArray(com("condition_of_tool"))) {
      conditionOfToolList = com("condition_of_tool");
    }
    if (code && code !== "") {
      for (let index in conditionOfToolList) {
        if (Number(conditionOfToolList[index].code) === Number(code)) {
          conditionOfToolName = conditionOfToolList[index].name;
          break;
        }
      }
    }
    return conditionOfToolName;
  };

  const getNote = (value: any) => {
    let note = "";
    if (value.length > 0) {
      data.claim_note.forEach((item: any) => {
        if (item.note_type === 10) {
          note = item.note;
        }
      });
    }
    return note;
  };

  const getPermisssionInfo = () => {
    let permisssions = false;
    if (
      props.userPermisssionInfo.job_allocation_authFlg ||
      props.userPermisssionInfo.job_register_authFlg ||
      props.userPermisssionInfo.jobdetail_general_authFlg ||
      props.userPermisssionInfo.jobdetail_parts_and_drawing_authFlg ||
      props.userPermisssionInfo.customer_info_authFlg ||
      props.userPermisssionInfo.delete_memo_authFlg ||
      props.userPermisssionInfo.price_authFlg ||
      props.userPermisssionInfo.delete_job_btn_authFlg
    ) {
      permisssions = true;
    }
    return permisssions;
  };

  const getName = (code: string, listName: string) => {
    let name = "";
    let list: any = [];
    if (Array.isArray(com(listName))) {
      list = com(listName);
    }
    if (code && code !== "") {
      for (let index in list) {
        if (Number(list[index].code) === Number(code)) {
          name = list[index].name;
          break;
        }
      }
    }
    return name;
  };

  return (
    <form noValidate autoComplete="off">
      <div>
        <div>
          <div className={classes.box}>
            {t("summary_title_repair_information")}
          </div>
          <div className={classes.row}>
            <span>{t("summary_txt_claim_number")}</span>
            <span>{data.claim_no}</span>
          </div>
          <div className={classes.row}>
            <span>{t("txt_customer_type")}</span>
            <span>
              {data.claim_address &&
                getName(data.claim_address.customer_type, "customer_type")}
            </span>
          </div>
          <div className={classes.row}>
            <span>{t("summary_txt_customer_po_no")}</span>
            <span>{data.customer_po_no}</span>
          </div>
          <div className={classes.row}>
            <span>{t("summary_txt_model_number")}</span>
            <span>{data.model_no}</span>
          </div>
          <div className={classes.row}>
            <span>{t("summary_txt_serial_number")}</span>
            {repairHistoryList.length > 0 && data.serial_no !== "*" && (
              <span
                className={classes.generalModelLink}
                onClick={() => {
                  openHistory();
                }}
              >
                {data.serial_no}
              </span>
            )}
            {(repairHistoryList.length === 0 || data.serial_no === "*") && (
              <span>{data.serial_no}</span>
            )}
          </div>
          {showHistoryFlg && (
            <div style={{ position: "absolute", zIndex: 10000 }}>
              <Table stickyHeader className={classes.root02}>
                <TableHead className={classes.thead}>
                  <TableRow>
                    <TableCell>
                      <div className={classes.tableHeadTitle}>
                        {t("summary_txt_repair_history")}
                      </div>

                      <IconButton
                        aria-label="close"
                        className={classes.closeBtn}
                        onClick={() => {
                          closeHistory();
                        }}
                      >
                        <CloseIcon className={classes.closeIcon} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.tbody}>
                  <TableContainer className={classes.groupContainer}>
                    {repairHistoryList.map((row: any, index: number) => {
                      let path: any;
                      if (row.type_kind === 1) {
                        path =
                          GetPrivateAppRoutePath(PathKey.JOBSDETAIL) +
                          `?jobno=${row.history_no}`;
                        if (getPermisssionInfo()) {
                          return (
                            <TableRow>
                              <TableCell>
                                <span>
                                  {!row.entry_date || row.entry_date === ""
                                    ? ""
                                    : date(new Date(row.entry_date).getTime())}
                                </span>
                                <span
                                  onClick={() => changeView(path)}
                                  className={classes.generalModelLink}
                                >
                                  {row.history_no}
                                </span>
                              </TableCell>
                            </TableRow>
                          );
                        } else {
                          return (
                            <TableRow>
                              <TableCell>
                                <span>
                                  {!row.entry_date || row.entry_date === ""
                                    ? ""
                                    : date(new Date(row.entry_date).getTime())}
                                </span>
                                <span
                                  className={
                                    classes.generalModelLinkNoUnderLine
                                  }
                                >
                                  {row.history_no}
                                </span>
                              </TableCell>
                            </TableRow>
                          );
                        }
                      } else {
                        path =
                          GetPrivateAppRoutePath(PathKey.SUMMARY) +
                          `?claimno=${row.history_no}`;
                        return (
                          <TableRow>
                            <TableCell>
                              <span>
                                {!row.entry_date || row.entry_date === ""
                                  ? ""
                                  : date(new Date(row.entry_date).getTime())}
                              </span>
                              <span
                                onClick={() => changeView(path)}
                                className={classes.generalModelLink}
                              >
                                {row.history_no}
                              </span>
                            </TableCell>
                          </TableRow>
                        );
                      }
                    })}
                  </TableContainer>
                </TableBody>
              </Table>
            </div>
          )}
          <div className={classes.row}>
            <span>{t("summary_txt_purchased_date")}</span>
            <span>
              {!data.purchased_date || data.purchased_date === ""
                ? ""
                : date(new Date(data.purchased_date).getTime())}
            </span>
          </div>
          <div className={classes.row}>
            <span>{t("txt_received_date")}</span>
            <span>
              {!data.received_date || data.received_date === ""
                ? ""
                : date(new Date(data.received_date).getTime())}
            </span>
          </div>
          <div className={classes.row}>
            <span>{t("summary_txt_repair_date")}</span>
            <span>
              {!data.repair_date || data.repair_date === ""
                ? ""
                : date(new Date(data.repair_date).getTime())}
            </span>
          </div>

          <div className={classes.row}>
            <span>{t("summary_txt_problem")}</span>
            <span>{getErrorTypeName(data.error_type)}</span>
          </div>
          <div className={classes.row}>
            <span>{t("txt_guarantee_type")}</span>
            <span>{getName(data.guarantee_type, "guarantee_type")}</span>
          </div>
          <div className={classes.row}>
            <span>{t("summary_txt_condition_of_tool")}</span>
            <span>{getConditionOfToolName(data.condition_of_tool)}</span>
          </div>
          <div className={classes.row}>
            <span>{t("summary_txt_special_remark")}</span>
            <span className={classes.spacialRemark}>
              {getNote(data.claim_note)}
            </span>
          </div>
          <div className={classes.pre_approve}>
            <div className={classes.pre_approve_title}>
              {t("summary_pre_approve")}
            </div>
            <div>
              <Checkbox
                className={classes.checkboxLayout}
                color="primary"
                checked={formList.pre_approve_flg}
                disabled={
                  (Number(dataList.status) !== 200 &&
                    Number(dataList.status) !== 210) ||
                  !userPermisssionInfo.wco_claim_pre_approve_authFlg
                }
                onChange={(e) =>
                  changeData("pre_approve_flg", e.target.checked)
                }
              />
              {/* <p className={classes.pre_approve_error}>{preApproveFlagError}</p> */}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};
